module.exports = __webpack_public_path__ + "static/menu-017af70e409bb223b3c81c61da8b8acf.png";